module.exports = __webpack_public_path__ + "static/coffee.4e2026a7.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/floaters/coffee.png
// module id = 1474
// module chunks = 168707334958949